export default __webpack_public_path__ + "static/media/allagain2022.f761186f.wav";